import React from "react";
import {
  Card,
  CardImg,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  FormGroup,
  Label,
  Button,
  ButtonGroup
} from "reactstrap";
import ImageUpload from "./ImageUpload";
import { CLOUDINARY_FULL_1 } from "../helpers/cloudinaryConstants";

const GeofenceCard = ({
  geofence,
  onCoverUpload,
  onCoverPreview,
  previewImage,
  onCancel,
  onSave,
  isUpdating,
  isPartnership,
  ...props
}) => {
  const coverImg =
    previewImage || `${CLOUDINARY_FULL_1}/${geofence.cover.image.cloudinaryId}`;

  const onSelect = geofence => {
    return () => {
      props.onSelect(geofence);
    };
  };

  return (
    <div>
      <Card>
        <CardBody>
          <CardTitle>{geofence.displayName}</CardTitle>
          <CardSubtitle>{geofence.slug}</CardSubtitle>
        </CardBody>
        <CardImg width="100%" src={coverImg} alt={geofence.displayName} />
        <CardBody>
          {!isPartnership ? (
            <FormGroup>
              <Label htmlFor="avatar">Change Cover Photo</Label>
              <ImageUpload
                id="geofence-cover-input"
                onUpload={onCoverUpload}
                onPreview={onCoverPreview}
                //noCompression
              />
            </FormGroup>
          ) : null}

          {isPartnership ? (
            <Button color="primary" onClick={onSelect(geofence)}>
              Add Geofence
            </Button>
          ) : (
            <ButtonGroup>
              <Button disabled={isUpdating} color="primary" onClick={onSave}>
                {isUpdating && (
                  <i
                    className="fa fa-circle-o-notch fa-spin"
                    style={{ marginRight: 5 }}
                  />
                )}
                Save Changes
              </Button>
              <Button disabled={isUpdating} color="danger" onClick={onCancel}>
                Cancel
              </Button>
            </ButtonGroup>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default GeofenceCard;



// WEBPACK FOOTER //
// ./src/components/GeofenceCard.js